export default __webpack_public_path__ + "static/media/picon.228f97d2.png";